import { render, staticRenderFns } from "./retailDaily.vue?vue&type=template&id=196ad748&scoped=true&"
import script from "./retailDaily.vue?vue&type=script&lang=js&"
export * from "./retailDaily.vue?vue&type=script&lang=js&"
import style0 from "./retailDaily.vue?vue&type=style&index=0&id=196ad748&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ad748",
  null
  
)

export default component.exports